import React from 'react';
import {
  useParams, useHistory
} from "react-router-dom";
import Config from './config';

function QrcodeChecking() {

  const { uuid }: { uuid: string } = useParams();
  let history = useHistory();

  const checkUuid = async () => {
    try {
      const res = await fetch(`${Config.apiUrl}store/v3/store/registration/${uuid}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
      }
      const resData = await res.json();
      const { result } = resData;
      
      if (result) {
        // Best way work in all browsers include safari
        // setTimeout(function(){document.location.href = `${Config.customerRegisterDomain}#/${result}`;},250);
        history.push(`/checkin/${result}`);
      }else{
        history.push(`/regisiter/${uuid}`);
      }


    } catch (error) {
      console.error(error.message)
      // setErrorMessage(error.message);
    }
  };
  if (uuid && uuid.length === 36) {
    checkUuid()
  }else{
    return (
      <div>
        invalid qrcode
      </div>
    );
  }


  return (
    <div>
      
    </div>
  );
}

export default QrcodeChecking;
